import { Directive, Input, HostBinding, OnInit } from '@angular/core';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { PublishService } from '../publish.service';
import { Store } from '@ngxs/store';
import { PublishState } from '../state/publish.state';
import { WidgetOptions } from '../models/widget-options.model';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';

@Directive({
  selector: 'iframe[appEmbedSrc]',
})
export class EmbedSrcDirective implements OnInit {
  @Input()
  params: WidgetOptions;

  @Input()
  set model(bookmark: BookmarkModel) {
    const widgetURL = this.store.selectSnapshot(PublishState.getWidgetURL);
    const lang = this.store.selectSnapshot(AuthState.getUserLanguage);
    const productAccountId = this.store.selectSnapshot(
      OrganizationsState.getSelectedOrganizationProductAccountId,
    );

    // build URL
    const url = this.publishService.getWidgetURL(
      bookmark,
      widgetURL,
      this.params,
      null,
      null,
      lang,
      null,
      productAccountId,
    );

    this.src = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  @Input()
  id: string;

  @HostBinding('src')
  src: SafeResourceUrl;

  constructor(
    private store: Store,
    private publishService: PublishService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {}
}
